<script>
import Flickity from 'flickity';
import fadeInUp from '../components/animations/FadeInUp.vue';
import linesUp from '../components/animations/LinesUp.vue';
import wordsUp from '../components/animations/WordsUp.vue';
import viewAllCard from '../components/ViewAllCard.vue';

export default {
    components: {
        fadeInUp,
        linesUp,
        wordsUp,
        viewAllCard
    },

    data() {
        return {
            flickity: null
        };
    },

    mounted() {
        if (this.$refs.slider) {
            this.flickity = new Flickity(this.$refs.slider, {
                cellAlign: 'left',
                prevNextButtons: false,
                pageDots: false,
                selectedAttraction: 0.01,
                friction: 0.18,
                imagesLoaded: true
            });
        }

        ScrollTrigger.refresh();
    },

    methods: {
        nextSlide() {
            this.flickity.next();
        }
    }
};
</script>
